import { ProductBlockHeaderLeft } from './components/ProductBlockHeaderLeft/ProductBlockHeaderLeft.js';
import { ProductBlockHeaderRight } from './components/ProductBlockHeaderRight/ProductBlockHeaderRight.js';
import { ProductBlockHeader as ProductBlockHeader$1 } from './ProductBlockHeader.js';

const ProductBlockHeader = Object.assign(ProductBlockHeader$1, {
    Left: ProductBlockHeaderLeft,
    Right: ProductBlockHeaderRight
});

export { ProductBlockHeader };
//# sourceMappingURL=index.js.map
